import { useUpdateUserLanguage } from '@/features/auth/hooks/useAuth'
import useI18n from '@/shared/hooks/useI18n'
import { LanguageSelector, OperatorLanguage } from '@/common'
import ReactCountryFlag from 'react-country-flag'

export const languages = [
  {
    label: 'English',
    value: OperatorLanguage.enGB,
    flag: <ReactCountryFlag countryCode="GB" svg />
  },
  {
    label: 'Türkçe',
    value: OperatorLanguage.trTR,
    flag: <ReactCountryFlag countryCode="TR" svg />
  },
  { label: '中文', value: OperatorLanguage.zhCN, flag: <ReactCountryFlag countryCode="CN" svg /> }
]

export default function OperatorLanguageSelector({ showLabel = false }: { showLabel?: boolean }) {
  const { handleChangeLanguage, currentLanguage } = useI18n()
  const { mutateAsync: updateLanguage } = useUpdateUserLanguage()

  const currentLanguageOption =
    languages.find(lang => lang.value === currentLanguage) || languages[0]
  const handleChange = (lang: string) => {
    handleChangeLanguage(lang)
    updateLanguage(lang)
  }

  return (
    <LanguageSelector
      languages={languages}
      currentLanguage={currentLanguageOption}
      onChange={handleChange}
      showLabel={showLabel}
    />
  )
}
